<template>
  <div v-if="!pending && giftCardPaymentDetails">
    <RevContainer
      class="bg-surface-brand-min flex w-full flex-col gap-16 py-40 md:flex-row md:items-start md:justify-center md:gap-64 md:py-72"
    >
      <div class="flex flex-col gap-16 md:flex-row md:justify-between md:gap-0">
        <div>
          <div class="text-static-default-hi body-1">
            {{ i18n(translations.subTitle) }}
          </div>
          <div class="text-static-default-hi heading-1">
            {{ i18n(translations.title) }}
          </div>
          <div class="text-static-default-hi body-1 mt-16">
            {{ i18n(translations.mainText) }}
          </div>
        </div>

        <GiftCardsInformation
          :expires-at="giftCardPaymentDetails.expiresAt"
          :image-url="giftCardPaymentDetails.designAsset.assetUrl"
          :price="giftCardPaymentDetails.price"
          :promo-token="giftCardPaymentDetails.promoToken"
        />
      </div>
    </RevContainer>

    <RevContainer class="my-40">
      <div class="heading-3">{{ i18n(translations.yourOrder) }}</div>

      <div class="grid-standard mt-24 gap-16 md:mt-32 md:gap-32">
        <OrderSummaryCard
          :billing-address="giftCardPaymentDetails.billingAddress"
          :created-at="giftCardPaymentDetails.createdAt"
          :order-number="giftCardPaymentDetails.orderNumber"
          :payment-method="giftCardPaymentDetails.paymentMethod"
        />

        <div class="md:col-span-9">
          <GiftCardsSummaryCard
            :image-url="giftCardPaymentDetails.designAsset.assetUrl"
            :price="giftCardPaymentDetails.price"
          />

          <div class="body-1-bold mt-32 flex justify-between">
            <div>{{ i18n(translations.total) }}</div>
            <div>
              {{ i18n.price(giftCardPaymentDetails.price) }}
            </div>
          </div>
        </div>
      </div>
    </RevContainer>
  </div>
</template>

<script setup lang="ts">
import { useAsyncData, useRoute } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'

import translations from './GiftCardsResults.translations'
import GiftCardsInformation from './components/GiftCardsInformation/GiftCardsInformation.vue'
import GiftCardsSummaryCard from './components/GiftCardsSummaryCard/GiftCardsSummaryCard.vue'
import OrderSummaryCard from './components/OrderSummaryCard/OrderSummaryCard.vue'

const i18n = useI18n()
const $httpFetch = useHttpFetch()
const route = useRoute()

const { data: giftCardPaymentDetails, pending } = await useAsyncData(() =>
  $httpFetch('/api/gift-cards/v1/payments/:requestId/details', {
    pathParams: { requestId: route.params.requestId.toString() },
  }),
)
</script>
